module.exports = __webpack_public_path__ + "static/OurValues1-mobile-177fd426dd1ffde9b05d57194cf4a1c8.png";